<div class="d-flex align-items-center justify-content-center order-tracker">
  @for (status of order_tracker_config; track status; let last = $last) {
    <span class="d-flex flex-column align-items-center">
      <span
        class="material-icons rounded-circle order-tracker-text"
        [ngClass]="{
          'd-none d-sm-block order-tracker__icon-inactive': !status.active,
          'order-tracker__icon-active': status.active,
          'text-bg-info': status.completed || status.active,
          'border border-danger text-bg-danger': status.denied,
          'border order-tracker-border-color': !status.completed && !status.denied
        }"
      >
        {{ status.step_icon }}
      </span>
      <span
        class="mt-2"
        [ngClass]="{
          'd-none d-md-block': !status.active,
          'fw-normal': status.completed || status.active
        }"
      >
        {{ status.step_name }}
      </span>
      <span [ngClass]="{ 'd-block d-md-none order-tracker__filler': !status.active }"></span>
    </span>
    @if (!last) {
      <hr aria-hidden="true" class="d-none d-sm-block d-lg-inline-block flex-grow-1 mb-5" />
    }
  }
</div>
